import * as React from 'react';
import { CheckMarkCircleIcon } from '../images/images';
import { colors } from '../styles/colors';

interface IProps {
    onClickPhoto?(): void;
    onClickCheckMark?(): void;
    url: string;
    photoIsSelected: boolean;
    photoHeight: number;
    isFullWidth?: boolean;
    imageStyle?: {};
    overrideHover: boolean;
}

interface IState {
    onHover: boolean;
}

export class MultiSelectSinglePhotoDisplay extends React.Component<IProps> {
    public state: IState = {
        onHover: false
    };

    public render() {
        return (
            <div
                style={{
                    ...styles.photoContainer,
                    height: this.props.photoHeight,
                    width: this.props.isFullWidth ? '100%' : '25%'
                }}
            >
                <div
                    style={{ position: 'relative', height: this.props.photoHeight - 20 }}
                    onMouseEnter={() => this.setState({ onHover: true })}
                    onMouseLeave={() => this.setState({ onHover: false })}
                >
                    <img src={this.props.url} style={{ ...styles.image, ...this.props.imageStyle } as React.CSSProperties} onClick={this.props.onClickPhoto} />
                    {(this.state.onHover || this.props.overrideHover) && (
                        <div style={styles.checkMarkContainer} onClick={this.props.onClickCheckMark}>
                            <div style={styles.checkMarkBorder(this.props.photoIsSelected)}>
                                {this.props.photoIsSelected && <img src={CheckMarkCircleIcon} style={styles.checkMarkCircle} />}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const styles = {
    checkMarkCircle: {
        height: '101%',
        width: '101%',
        objectFit: 'cover'
    } as React.CSSProperties,
    actionBar: {
        position: 'absolute',
        bottom: 0
    } as React.CSSProperties,
    photoContainer: {
        width: '25%',
        padding: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    } as React.CSSProperties,
    image: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
        objectPosition: 'top'
    } as React.CSSProperties,
    checkMarkContainer: {
        position: 'absolute',
        top: 0,
        padding: 10,
        left: 0,
        borderRadius: 20,
        width: 50,
        height: 50,
        cursor: 'pointer'
    } as React.CSSProperties,
    checkMarkBorder: (isSelected: boolean) => {
        return {
            border: isSelected ? '' : '2px solid ' + colors.ACTION_GREEN,
            borderRadius: 20,
            width: 30,
            height: 30
        } as React.CSSProperties;
    }
};



// WEBPACK FOOTER //
// ./src/SharedComponents/MultiSelectSinglePhotoDisplay.tsx